import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './lib/auth-fetch';
import './styles/theme.css';

// Apply dark theme by default (matches prototype)
document.documentElement.setAttribute('data-theme', 'dark');

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found. Ensure index.html contains a <div id="root"></div>.');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA capabilities
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js');
  });
}
